import ActionRow from '@shared/components/core/row/ActionRow';
import { obscureString } from '@shared/hooks/helpers/ObscureText';
import LicenseKeyModel from '@shared/models/organizations/LicenseKeyModel';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LicenseKeyAssignDialog from './LicenseKeyAssignDialog';
import LicenseKeyDetailsDialog from './LicenseKeyDetailsDialog';

export interface ILicenseKeyActionRowProps {
    licenseKey: LicenseKeyModel;
}

export default function LicenseKeyActionRow({ licenseKey }: ILicenseKeyActionRowProps) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    if (!licenseKey) return null;
    return (
        <>
            <ActionRow
                iconSize={24}
                startIcon={licenseKey.organizationId ? 'check' : 'circle'}
                endIcon="more"
                title={licenseKey.name}
                description={
                    licenseKey.organizationId
                        ? t('common:used', 'Used', { value: licenseKey.modifiedDate })
                        : obscureString(licenseKey.accessCode)
                }
                onClick={() => setOpen(true)}></ActionRow>
            {licenseKey.organizationId ? (
                <LicenseKeyDetailsDialog open={open} onClose={() => setOpen(false)} licenseKey={licenseKey} />
            ) : (
                <LicenseKeyAssignDialog open={open} onClose={() => setOpen(false)} licenseKey={licenseKey} />
            )}
        </>
    );
}
